import { Injector } from "@angular/core";
import { IHttpService } from "./http.service";
import { environment } from "../../../environments/environment";
import { CoreCOMService } from "./com.service";
import { YourAppServerApi } from "./YourAppServer/YourAppServerApi.service";
import { YourAppServerSoket } from "./YourAppServer/YourAppServerSoket.service";
import { YourAppServerAuth } from "./YourAppServer/YourAppServerAuth.service";
import { YourAppServerUser } from "./YourAppServer/YourAppServerUser.service";
import { CoreLogService } from "./log.service";
import { SettingsService } from "./settings.service";

// export const _IYourAppServer = new InjectionToken<IYourAppServer>('_IYourAppServer');
// interface um zirkelbezug umgehen
export interface IYourAppServer {
  readonly httpService: IHttpService;
  readonly BaseURI: string;
  readonly coreCOMService: CoreCOMService;
  readonly coreLogService: CoreLogService;
  readonly settingsService: SettingsService;
  readonly injector: Injector;
  readonly Api: YourAppServerApi;
  /**
   * This socket is used for InHouseOrder.
   */
  readonly Socket: YourAppServerSoket;
  readonly PreOrderSocket: YourAppServerSoket;
  readonly Auth: YourAppServerAuth;
  readonly User: YourAppServerUser;
}

/** YourAppServer hält Api, Auth und User vom YourAppServer zusammen */
export class YourAppServer implements IYourAppServer {

  public readonly BaseURI: string = environment.YourAppServer.BaseURI;
  public readonly Api: YourAppServerApi;
  public readonly Socket: YourAppServerSoket;
  public readonly PreOrderSocket: YourAppServerSoket;
  public readonly Auth: YourAppServerAuth;
  public readonly User: YourAppServerUser;

  constructor(public readonly coreCOMService: CoreCOMService,
    public readonly coreLogService: CoreLogService,
    public readonly httpService: IHttpService,
    public readonly settingsService: SettingsService,
    public readonly injector: Injector) {
      this.Api = new YourAppServerApi(this);
      this.Socket = new YourAppServerSoket(this);
      this.PreOrderSocket = new YourAppServerSoket(this);
      this.Auth = new YourAppServerAuth(this);
      this.User = new YourAppServerUser(this);
  }

}
